import {Injectable} from '@angular/core';

@Injectable()
export class CookieService {

  getCookie(key: string) {
    const cookie = document.cookie.split('; ')
      .find(part => part.split('=')[0] === key);
    return cookie ? cookie.split(`${key}=`)[1] : undefined;
  }

  deleteCookie(key: string) {
    document.cookie = `${key}=; expires=Tue, 01 Jan 1980 00:00:01 GMT;path=/;`;
  }

  saveCookie(key: string, value: string, expiresInDays: number) {
    let expires = '';
    if (expiresInDays) {
      const date = new Date();
      date.setTime(date.getTime() + (expiresInDays * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = key + '=' + value + expires + '; path=/';
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/access-token/cookie.service.ts